import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    paymentIntentID: "",
    clientSecret: "",
    customerID: "",
    firedPurchaseEvent: false,
};

const stripeSlice = createSlice({
    name: "stripe",
    initialState,
    reducers: {
        reset: (state, action) => {
            return { ...initialState };
        },
        setPaymentIntent: (state, action) => {
            state.paymentIntentID = action.payload["id"];
            state.clientSecret = action.payload["client_secret"];
            state.customerID = action.payload["customer"];
        },
        setPaymentIntentID: (state, action) => {
            state.paymentIntentID = action.payload;
        },
        setClientSecret: (state, action) => {
            state.clientSecret = action.payload;
        },
        setCustomerID: (state, action) => {
            state.customerID = action.payload;
        },
        setFiredPurchaseEvent: (state, action) => {
            state.firedPurchaseEvent = action.payload;
        },
        setStripeFromAbandonedCart: (state, action) => {
            const stripeId = action.payload?.patient?.fields?.stripe_id;
            if (stripeId) state.customerID = stripeId;
        },
    },
});

export const { reset, setPaymentIntent, setPaymentIntentID, setClientSecret, setCustomerID, setFiredPurchaseEvent, setStripeFromAbandonedCart } = stripeSlice.actions;

export default stripeSlice.reducer;
